export default "/images/Banner_chamada.png?b0af673c32d1ce2c99db179c40a10486";